import React from "react";
import { Col, Spin } from "antd";
import SmartIcon from "../../components/generic/genericIcon/SmartIcon";

/**
 * Metric column for the billing account summary grid (icon + title + value + subtitle).
 */
function AccountSummaryMetricCol({
  xs = 24,
  md = 8,
  loading = false,
  iconKey,
  title,
  value,
  subtitle,
}) {
  if (loading) {
    return (
      <Col xs={xs} md={md}>
        <article
          className="account-summary-metric-card account-summary-metric-card--loading"
          aria-busy="true"
          aria-label="Loading"
        >
          <Spin size="medium" />
        </article>
      </Col>
    );
  }

  return (
    <Col xs={xs} md={md}>
      <article className="account-summary-metric-card">
        <div className="account-summary-metric-icon" aria-hidden>
          <SmartIcon iconKey={iconKey} />
        </div>
        <div className="account-summary-metric-body">
          <h3 className="account-summary-metric-title">{title}</h3>
          <p className="account-summary-metric-value">{value}</p>
          <p className="account-summary-metric-sub">{subtitle}</p>
        </div>
      </article>
    </Col>
  );
}

export default AccountSummaryMetricCol;
